import { credentialDetailSchema } from '../models/account-carrier.ts'
import {
  vArray,
  vBoolean,
  vFormattedPhoneNumber,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

const detailsArraySchema = vArray(credentialDetailSchema)

export const accountCarrierUpdateSchema = vObject({
  salesRepFirstName: vOptional(vString()),
  salesRepLastName: vOptional(vString()),
  salesRepPhone: vOptional(vFormattedPhoneNumber()),
  salesReps: vOptional(
    vArray(
      vObject({
        email: vString(),
      }),
    ),
  ),
  isBeta: vOptional(vBoolean()),
  enableLTL: vOptional(vBoolean()),
  enableParcel: vOptional(vBoolean()),
  enableTL: vOptional(vBoolean()),
  disableProNumbers: vOptional(vBoolean()),
  notified: vOptional(vBoolean()),
  details: vOptional(detailsArraySchema),
})
export type UpsertAccountCarrierDto = vOutput<typeof accountCarrierUpdateSchema>

export const bulkAccountCarrierBetaUpdateSchema = vObject({
  accountIds: vArray(vObjectId()),
  isBeta: vBoolean(),
})
export type BulkAccountCarrierBetaUpdateDto = vOutput<
  typeof bulkAccountCarrierBetaUpdateSchema
>
